// extracted by mini-css-extract-plugin
export default {"ul":"Feedback_ul__uOtrg","btn-btn":"Feedback_btn-btn__PTkAV","btn":"Feedback_btn__sEonR"};